module.exports = __webpack_public_path__ + "img/s3Model6.61055799.webp";